import React from "react"
const Access = cell => {
    return cell && cell.value === true ? <i className="mdi mdi-check-bold me-2 text-success" /> : cell.value === false ? <i className="mdi mdi-close-thick me-2 text-danger" /> : '';
};
const GroupName = (cell) => {
    return cell && cell.value;
};

export {
    Access,
    GroupName
};